import React, { useState } from 'react';
import { Box, Typography, Popover, IconButton, Tooltip } from '@material-ui/core';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

function onCopyIncidentsID(codes) {
  const textToCopy = codes.join(', ');
  navigator.clipboard
    .writeText(textToCopy)
    .catch((err) => {
      console.error('Error al copiar al portapapeles: ', err);
    });
}

export function HourlyDetailTableFormatDayHeader({
  diaStr,
  locale,
  dayCodes,
  disablePopover,
}) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const d = new Date(diaStr + 'T00:00:00');
  const loc = locale || 'es';
  const weekday = d.toLocaleDateString(loc, { weekday: 'short' });
  const dayNum = String(d.getDate()).padStart(2, '0');
  const label = `${weekday.charAt(0).toUpperCase() + weekday.slice(1).replace('.', '')} ${dayNum}`;

  const hasCodes = dayCodes && dayCodes.length > 0;

  const handleClick = (e) => {
    if (disablePopover) return;
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <span
        onClick={handleClick}
        style={{ cursor: disablePopover ? 'default' : 'pointer' }}
      >
        {label}
      </span>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        style={{ zIndex: 10001 }}
        PaperProps={{
          style: {
            backgroundColor: '#0A1938',
            borderRadius: 12,
            padding: '12px 16px',
            maxWidth: 280,
            overflow: 'visible',
            boxShadow: '0px 4px 20px rgba(4, 6, 34, 0.15)',
            marginTop: -16,
          },
        }}
      >
        {/* Arrow tip */}
        <Box
          style={{
            position: 'absolute',
            bottom: -6,
            left: '50%',
            transform: 'translateX(-50%) rotate(45deg)',
            width: 12,
            height: 12,
            backgroundColor: '#0A1938',
            borderRadius: 2,
          }}
        />
        <Typography
          variant="body2"
          style={{ fontWeight: 600, color: '#fff', marginBottom: 4 }}
        >
          {t('ind.hourly.incidentes')}
        </Typography>
        {hasCodes ? (
          <Box display="flex" alignItems="flex-start">
            <Box flex={1} style={{ maxHeight: 200, overflowY: 'auto' }}>
              {dayCodes.map((code) => (
                <Typography
                  key={code}
                  variant="body2"
                  style={{ color: '#fff', fontSize: '0.75rem' }}
                >
                  ID: {code}
                </Typography>
              ))}
            </Box>
            <Tooltip title={t('ind.copyIds')} placement="top">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onCopyIncidentsID(dayCodes);
                }}
                size="small"
                style={{ marginLeft: 8 }}
              >
                <ContentCopyIcon style={{ fontSize: 14, color: '#fff' }} />
              </IconButton>
            </Tooltip>
          </Box>
        ) : (
          <Typography
            variant="body2"
            style={{ color: '#9F9F9F', fontSize: '0.75rem' }}
          >
            {t('ind.incidents.empty')}
          </Typography>
        )}
      </Popover>
    </>
  );
}
